import req from "../../http";

const dl = {
  // 取得 面談背景資料
  getWorkedInfo(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetWorkedInfo/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetWorkedInfo/${candidate}`);
    }
  },

  // 編輯 面談背景資料
  putWorkedInfo(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditWorkedInfo", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditWorkedInfo", params);
    }
  },
  // 取得 基本資料
  getBaseInfo(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetBaseInfo/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetBaseInfo/${candidate}`);
    }
  },

  // 編輯 基本資料
  putBaseInfo(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditBaseInfo", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditBaseInfo", params);
    }
  },

  // 取得 工作條件
  getWorkCondition(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetWorkCondition/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetWorkCondition/${candidate}`);
    }
  },

  // 編輯 工作條件
  putWorkCondition(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditWorkCondition", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditWorkCondition", params);
    }
  },

  // 取得 學歷
  getEducation(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetEducation/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetEducation/${candidate}`);
    }
  },

  // 編輯 學歷
  putEducation(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditEducation", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditEducation", params);
    }
  },

  // 取得 工作經歷
  getWorkExperience(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetWorkExperience/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetWorkExperience/${candidate}`);
    }
  },

  // 編輯 工作經歷
  putWorkExperience(source, params) {
    if (source === "resume") {
    // 履歷
      return req("put", "/ResumeModule/DL/EditWorkExperience", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditWorkExperience", params);
    }
  },

  // 取得 專業技能及認證
  getSkill(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetSkill/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetSkill/${candidate}`);
    }
  },

  // 編輯 專業技能及認證
  putSkill(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditSkill", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditSkill", params);
    }
  },

  // 取得 自傳
  getAutobiography(source, candidate) {
    if (source === "resume") {
      // 履歷
      return req("get", `/ResumeModule/DL/GetAutobiography/${candidate}`);
    } else {
      // 人事資料表
      return req("get", `/Recruitment/PersonnelInformation/DL/GetAutobiography/${candidate}`);
    }
  },

  // 編輯 自傳
  putAutobiography(source, params) {
    if (source === "resume") {
      // 履歷
      return req("put", "/ResumeModule/DL/EditAutobiography", params);
    } else {
      // 人事資料表
      return req("put", "/Recruitment/PersonnelInformation/DL/EditAutobiography", params);
    }
  },
};

export default dl;